import { z } from 'zod';
export const IqAnalysisWidgetKey = 'iq-analysis-widget:v1';
export const IqAnalysisWidgetKind = 'iq_analysis';
export const IQ_ANALYSIS_ARTIFACT_KEY_PREFIX = 'iq-analysis:';
/**
 * The artifact stores identifying metadata only. The Library preview reads the
 * live analysis from the core API via the id encoded in the artifact key, so the
 * report body (structured data, citations, YouGov/Pathmatics) is deliberately
 * not duplicated here — it would be a second copy to keep in sync and it dwarfs
 * every other artifact payload.
 *
 * What is stored is enough to label and sort the row without a fetch, and to
 * keep the row meaningful if the analysis itself is later removed.
 */
export const IqAnalysisWidgetSchema = z.object({
    brandName: z.string(),
    query: z.string().nullable().optional(),
    category: z.string().nullable().optional(),
    website: z.string().nullable().optional(),
    timeframe: z.string().nullable().optional(),
    markets: z.array(z.string()).nullable().optional(),
    completedAt: z.string().nullable().optional(),
});
